import { Modal } from 'ant-design-vue';
import { h } from 'vue';

export default {
  mounted(el, binding) {
    const options = binding.value || {};

    // 保存原始图片地址
    el.setAttribute('data-original-src', el.src);

    el.style.cursor = 'pointer';
    el.addEventListener('click', () => {
      Modal.info({
        title: '图片预览',
        icon: null,
        content: () => {
          // 使用当前最新的图片地址
          const currentSrc = el.getAttribute('data-current-src') || el.getAttribute('data-original-src');
          return h('img', {
            src: currentSrc,
            style: {
              width: options.width ? `${options.width}px` : '100%',
              maxWidth: '100%',
              height: 'auto',
              objectFit: 'contain'
            }
          });
        },
        centered: true,
        closable: true,
        destroyOnClose: true,
        maskClosable: true,
        width: options.width ? `${options.width}px` : '800px',
        style: {
          maxWidth: '100vw',
          maxHeight: '95vh',
        },
        class: 'custom-dialog custom-info-dialog',
        wrapClassName: 'image-preview-modal',
        zIndex: options.zIndex || 1000,
        okText: '关闭'
      });
    });
  },

  updated(el, binding) {
    const newSrc = binding.value?.src;
    const oldSrc = binding.oldValue?.src;

    if (newSrc !== oldSrc) {
      if (newSrc) {
        // 更新缩略图
        el.src = newSrc;
        // 更新当前图片地址
        el.setAttribute('data-current-src', newSrc);

        // 如果有打开的 Modal，关闭它
        const modalElement = document.querySelector('.ant-modal-wrap');
        if (modalElement) {
          Modal.destroyAll();
        }
      } else {
        el.src = el.getAttribute('data-original-src');
        el.removeAttribute('data-current-src');
      }
    }
  },

  unmounted(el) {
    el.removeAttribute('data-current-src');
    el.removeAttribute('data-original-src');
  }
};